import React from 'react';
import { FIRELINE_MEDIC_BADGE } from './firelineMedicBadge';
import { authenticatedTenantBrand } from './tenantBrand';
import './tenant-brand.css';

export default function TenantBrandLockup({ profile, compact = false, className = '' }) {
  const brand = authenticatedTenantBrand(profile);

  return (
    <div className={`tenant-brand-lockup${compact ? ' tenant-brand-lockup--compact' : ''}${className ? ` ${className}` : ''}`.trim()}>
      <div className="tenant-brand-lockup__mark">
        <img
          src={brand.logo}
          alt={brand.coBranded ? `${brand.shortTenantName} Line Medic` : 'Line Medic'}
          onError={event => {
            if (event.currentTarget.src.endsWith(FIRELINE_MEDIC_BADGE)) return;
            event.currentTarget.src = FIRELINE_MEDIC_BADGE;
          }}
        />
      </div>
      <div className="tenant-brand-lockup__copy">
        <span>{brand.kicker}</span>
        <strong>{brand.productName}</strong>
        {brand.coBranded && <small>{brand.shortTenantName}</small>}
      </div>
    </div>
  );
}
